import React from "react";
import { Lock } from "lucide-react";

export function PermissionMatrix({ modules, actions, value, onChange, readOnly = false }) {
  const has = (m, a) => ((value || {})[m] || []).includes(a);
  const toggle = (m, a) => {
    if (readOnly) return;
    const cur = new Set((value || {})[m] || []);
    if (cur.has(a)) { cur.delete(a); if (a === "voir") cur.clear(); } else { cur.add(a); cur.add("voir"); }
    const next = { ...(value || {}) };
    if (cur.size) next[m] = actions.map((x) => x.key).filter((k) => cur.has(k)); else delete next[m];
    onChange?.(next);
  };
  const toggleRow = (m) => {
    if (readOnly) return;
    const all = actions.map((a) => a.key);
    const next = { ...(value || {}) };
    if (((value || {})[m] || []).length === all.length) delete next[m]; else next[m] = all;
    onChange?.(next);
  };
  return (
    <div className="border border-[#0A0A0A] bg-white overflow-x-auto" data-testid="permission-matrix">
      <table className="w-full text-xs border-collapse">
        <thead>
          <tr className="bg-[#0A0A0A] text-white">
            <th className="text-left px-3 py-2 uppercase tracking-[0.2em] font-bold text-[10px] min-w-[220px]">Module</th>
            {actions.map((a) => <th key={a.key} className="px-2 py-2 uppercase tracking-wider font-bold text-[10px] text-center min-w-[74px]">{a.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {modules.map((m) => (
            <tr key={m.key} className={`border-b border-[#DEE2E6] ${m.locked ? "bg-[#F8F9FA] text-[#868E96]" : "hover:bg-[#F8F9FA]"}`} data-testid={`perm-row-${m.key}`}>
              <td className="px-3 py-2">
                <button type="button" onClick={() => !m.locked && toggleRow(m.key)} disabled={m.locked || readOnly} className="text-left font-semibold hover:underline disabled:no-underline disabled:cursor-default flex items-center gap-1.5" data-testid={`perm-row-toggle-${m.key}`}>
                  {m.locked && <Lock className="h-3 w-3" />} {m.label}
                </button>
              </td>
              {actions.map((a) => (
                <td key={a.key} className="text-center px-2 py-1.5">
                  {m.locked ? <span className="text-[#DEE2E6]">—</span> : (
                    <button type="button" onClick={() => toggle(m.key, a.key)} disabled={readOnly} data-testid={`perm-${m.key}-${a.key}`}
                            aria-pressed={has(m.key, a.key)}
                            className={`h-7 w-7 border transition-colors ${has(m.key, a.key) ? "bg-[#002FA7] border-[#002FA7] text-white" : "border-[#DEE2E6] hover:border-[#0A0A0A]"} disabled:cursor-default`}>
                      {has(m.key, a.key) ? "✓" : ""}
                    </button>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
